// extracted by mini-css-extract-plugin
export default {"container":"CaseDetail_container__-7OLz","navigateBack":"CaseDetail_navigateBack__qGkZm","button":"CaseDetail_button__O-B1b","main":"CaseDetail_main__EAUXO"};